import React from 'react';
import { TextField } from '@mui/material';

type PropsType = {
    label: string,
    variant?: 'standard' | 'filled' | 'outlined',
    fullWidth?: boolean,
    value?: string,
    autoFocus?: boolean,
    [key: string]: any
};

const Input: React.FC<PropsType> = (props) => {
    const {
        value,
        label,
        variant = 'standard',
        fullWidth = true,
        ...restProps
    } = props;

    return (
        <TextField
            label={label}
            variant={variant}
            fullWidth={fullWidth}
            {...restProps}
            InputLabelProps={value ? { shrink: true } : {}}
            value={value}
        />
    );
};

export default Input;
